import React from 'react';
import { formatDistance } from '@utils/routeHelpers';

export const StructuresList = ({ structures = [], onSelect }) => {
  if (structures.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        No structures found along this route
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium text-white">
        Structures ({structures.length})
      </h2>

      <div className="space-y-3">
        {structures.map((structure) => (
          <button
            key={structure.id}
            onClick={() => onSelect(structure)}
            className="w-full text-left bg-gray-700/50 p-4 rounded-lg hover:bg-gray-700 transition-colors"
          >
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-medium text-white">
                  {structure.name || `Structure ${structure.id}`}
                </h3>
                <p className="text-sm text-gray-400 mt-1">
                  Type: {structure.type}
                </p>
                {structure.properties?.clearance && (
                  <p className="text-sm text-gray-400">
                    Clearance: {structure.properties.clearance}m
                  </p>
                )}
                {structure.distanceFromRoute && (
                  <p className="text-sm text-gray-400">
                    Distance from route: {formatDistance(structure.distanceFromRoute)}
                  </p>
                )}
              </div>
              {structure.properties?.condition && (
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  structure.properties.condition === 'good' ? 'bg-green-500/20 text-green-400' :
                  structure.properties.condition === 'fair' ? 'bg-yellow-500/20 text-yellow-400' :
                  'bg-red-500/20 text-red-400'
                }`}>
                  {structure.properties.condition}
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};